import { supabase } from "@/integrations/supabase/client";

/**
 * The site's own lead forms (Anand, 17 Oct 26: "wire them up and let them land in email to me and manu"): /agency's
 * free GMB audit and /individuals' free growth plan. Both go through send-managed-inquiry, which picks the
 * recipients from the source (Anand and Manu for these two), stores the lead in managed_inquiries and sends the
 * visitor a receipt. The page never names a recipient.
 */
export type SiteLeadSource = "agency-page" | "individuals-page";

export interface SiteLead {
  name: string;
  email: string;
  phone: string;
  businessName: string;
}

/** Sends the lead; throws when the function refuses or cannot be reached, so the form can say so. */
export async function sendSiteLead(source: SiteLeadSource, lead: SiteLead): Promise<void> {
  const body = {
    name: lead.name.trim(),
    email: lead.email.trim(),
    phone: lead.phone.trim(),
    businessName: lead.businessName.trim(),
    source,
  };
  const { error } = await supabase.functions.invoke("send-managed-inquiry", { body });
  if (error) throw error;
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "site_lead_submit", form_name: source });
  }
}

/** The line a form shows when the lead did not send: what failed and the other way to reach the team. */
export const SITE_LEAD_ERROR = "Your details didn't send. Try again, or message us on WhatsApp at +91 84467 12833.";
